import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useClientInfoStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%',

            [theme.breakpoints.up('md')]: {
                height: '188px',
                paddingTop: '5px'
            }
        },
        info: {
            gap: 6,
            alignItems: 'center'
        },
        icon: {
            width: 20,
            height: 26,
            color: '#000'
        },
        tagContent: {
            gap: '7px 4px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'start',
            paddingTop: 10,
            paddingBottom: 24,

            [theme.breakpoints.down('sm')]: {
                borderBottom: '1px solid #d4d4d4'
            }
        },
        clientTag: {
            color: '#fff',
            height: 'auto',
            fontSize: 13,
            fontWeight: 500,
            padding: '5.5px 0px',
            backgroundColor: '#BCB8AE'
        },
        typo: {
            color: '#222'
        }
    })
);
